/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefetchContainer_itemSearch = {
    readonly pageType: string | null;
    readonly vanityUriRef: string | null;
    readonly displayUriRef: string | null;
    readonly " $refType": "SbSharedRefetchContainer_itemSearch";
};
export type SbSharedRefetchContainer_itemSearch$data = SbSharedRefetchContainer_itemSearch;
export type SbSharedRefetchContainer_itemSearch$key = {
    readonly " $data"?: SbSharedRefetchContainer_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefetchContainer_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefetchContainer_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vanityUriRef",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUriRef",
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '56f0d134e98dd2feb516b4d2c51167d4';
export default node;
